// Generated by CoffeeScript 2.7.0
var AttachmentLayer;

import ModalMixin from 'trunks/vue/admin/mixins/modal.js';

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

export default AttachmentLayer = Vue.extend({
  mixins: [ModalMixin],
  components: {
    'user-item': UserItem
  },
  props: {
    extendClass: {
      type: String
    },
    thumbnailsListMaxWidth: {
      type: Number,
      default: 720
    },
    perDeltaX: {
      type: Number,
      default: 40
    },
    perDeltaCount: {
      type: Number,
      default: 3
    }
  },
  data: function() {
    return {
      attachments: [],
      opened: true,
      currentIndex: 0,
      deltaX: 0,
      transformOrigin: ''
    };
  },
  template: `<div class="attachment-layer"
     :class="[statusClass, extendClass]"
     tabIndex="-1"
     @keyup.left="previewPrev"
     @keyup.right="previewNext"
     v-animationend.stop='animationEnd'>
  <div class="attachemnt-layer-underlay"></div>
  <div class="attachment-layer-header">
    <div class="btn icon-btn close-btn">
      <i class="slp-times"></i>
    </div>
  </div>
  <div ref="previewContent" class="attachment-layer-content">
    <div class="attachment-preview-wrapper"
         v-for="attachment in attachments"
         :key="attachment.id"
         :style="\`visibility: \${_isCurrentAttachment(attachment) ? 'visible' : 'hidden'}\`">
      <img :src="previewUrl(attachment)"
           :style="{
            transform: \`scale(\${attachment._scale})\`
           }"
           alt="pic"
           class="attachment-preview"
           v-if="canPreview(attachment) && attachment.id"
           @load="initImageScale($event, attachment)"
           @click="download" />
      <video v-if="canPlay(attachment)"
             class="attachment-preview"
             controls>
        <source :src="downloadUrl(attachment)"
                type="video/mp4"/>
      </video>
      <div class="attachment-preview"
           :class="attachmentClass(attachment)"
           v-if="!(canPreview(attachment) || canPlay(attachment)) && attachment.id"
           @click="previewFile">
        <file-icon :type='attachment.extension' size='large' />
      </div>
      <div class="attachment-preview null-attachment content-centered"
           v-if="!attachment.id">
        <i class="slp-image"></i>
      </div>
    </div>
  </div>
  <div class="attachment-layer-footer">
    <div class="attachments-control">
      <div class="btn icon-btn"
           :class="{'disabled': !hasPrevious}"
           @click="previewPrev">
        <i class="slp-chevron-left"></i>
      </div>
      <div class="indicator">
        {{ currentIndex + 1 }} / {{ attachments.length }}
      </div>
      <div class="btn icon-btn"
           :class="{'disabled': !hasNext}"
           @click="previewNext">
        <i class="slp-chevron-right"></i>
      </div>
    </div>
    <div class="attachment-name">{{ currentAttachment.name }}</div>
    <div class="attachment-info">
      <user-item :user='user' size='small'></user-item>
      <span v-if='currentAttachment._error_message'>上传失败</span>
      <span v-else>{{ attachmentSize }}</span>
      <div class="btn text-btn white-text" @click="reupload" v-if='currentAttachmentCanReload'>
        <i class="slp-refresh"></i>
        <span>重新上传</span>
      </div>
      <div class="btn text-btn white-text" @click="download" v-if='currentAttachment.id'>
        <i class="slp-down-circle-o"></i>
        <span>下载</span>
      </div>
      <div class="btn text-btn white-text" :class="{'disabled': !canPreview(currentAttachment)}" @click='rotate'>
        <i class="slp-rotate"></i>
        <span>旋转</span>
      </div>
      <div class="btn text-btn white-text" :class="{'disabled': !canPreview(currentAttachment)}" @click="scale('zoomIn')">
        <i class="slp-zoom-in"></i>
        <span>放大</span>
      </div>
      <div class="btn text-btn white-text" :class="{'disabled': !canPreview(currentAttachment)}" @click="scale('zoomOut')">
        <i class="slp-zoom-out"></i>
        <span>缩小</span>
      </div>
    </div>
    <div class="attachments-thumbnails-preview">
      <div class="btn icon-btn link-btn btn-large squared forward"
           @click="listForward"
           v-if="listHasPrevious">
        <i class="slp-chevron-left"></i>
      </div>
      <div class="btn icon-btn link-btn btn-large squared backward"
           @click="listBackward"
           v-if="listHasNext">
        <i class="slp-chevron-right"></i>
      </div>
      <div class="thumbnails-view"
           :style="{'max-width': thumbnailsListMaxWidth + 'px'}">
        <div class="attachments attachment-thumbnails"
             :style="{'transform': 'translateX(' + deltaX + 'px)'}">
          <div class="attachment-item"
               v-for="(attachment, index) in attachments"
               :key="attachment.id"
               :class="[canPreview(attachment), {'active': _isCurrentAttachment(attachment) }, {'null-attachment': !attachment.id}]"
               @click="clickAttachment(index)">
            <img :src="_croppedAttachmentUrl(attachment)"
                 alt="pic"
                 v-if="canPreview(attachment) && attachment.id" />
            <file-icon :type='attachment.extension' size='small' v-if="!canPreview(attachment) && attachment.id"/>
            <i class="slp-image" v-if="!attachment.id"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    return this._calculateDeltaXAccordingIndex(false);
  },
  mounted: function() {
    return this._focusLayer();
  },
  computed: {
    hasPreview: function() {
      return _global.namespace.third_preview_attachment;
    },
    currentAttachment: function() {
      return this.attachments[this.currentIndex];
    },
    attachmentSize: function() {
      return Skylark.Helpers.FileHelper.humanSize(this.currentAttachment.size);
    },
    hasPrevious: function() {
      return this.currentIndex !== 0;
    },
    hasNext: function() {
      return this.currentIndex !== this.attachments.length - 1;
    },
    listHasPrevious: function() {
      return this.deltaX < 0;
    },
    listHasNext: function() {
      return Math.abs(this.deltaX) < this.thumbnailsListWidth - this.thumbnailsListMaxWidth;
    },
    thumbnailsListWidth: function() {
      return this.attachments.length * this.perDeltaX;
    },
    user: function() {
      return this.currentAttachment.author;
    },
    isThumbnailsListOverlength: function() {
      // 列表超长
      return Boolean(this.attachments.length >= (this.thumbnailsListMaxWidth / this.perDeltaX));
    },
    listViewLastIndex: function() {
      if (this.isThumbnailsListOverlength) {
        // 倒数第二个
        return (this.thumbnailsListMaxWidth + Math.abs(this.deltaX)) / this.perDeltaX - 2;
      } else {
        return this.attachments.length - 1;
      }
    },
    listViewFirstIndex: function() {
      if (this.isThumbnailsListOverlength) {
        // 正数第二个
        return (Math.abs(this.deltaX / this.perDeltaX)) + 1;
      } else {
        return 0;
      }
    },
    currentAttachmentCanReload: function() {
      return this.currentAttachment._error_message && (this.currentAttachment.size <= this.currentAttachment.limitSize) && !this.currentAttachment.id;
    }
  },
  watch: {
    deltaX: function() {
      return this._adjustDeltaX();
    }
  },
  methods: {
    open: function() {
      if (this.opened) {
        return;
      }
      this.opened = true;
      this._focusLayer();
      return this.__enableBackdrop();
    },
    attachmentClass: function(attachment) {
      return {
        'attachment-type': !this.canPreview(attachment)
      };
    },
    downloadUrl: function(attachment) {
      return `/attachments/${attachment.id}/download`;
    },
    previewUrl: function(attachment) {
      if (attachment._rotate) {
        return `/attachments/${attachment.id}/download_url?fops=imageMogr2/rotate/${attachment._rotate}`;
      } else {
        return `/attachments/${attachment.id}/download_url`;
      }
    },
    previewFileUrl: function(download_url) {
      return window.location = "https://view.xdocin.com/xdoc?_xdoc=" + encodeURIComponent(download_url);
    },
    canPreview: function(attachment) {
      return attachment.extension === 'image';
    },
    canPlay: function(attachment) {
      return attachment.extension === 'video';
    },
    download: function() {
      return window.open(this.downloadUrl(this.currentAttachment));
    },
    previewFile: function() {
      if (this.hasPreview) {
        return Skylark.Libs.Ajax.get(`/attachments/${this.currentAttachment.id}/download_url`, {
          responseType: 'json',
          success: (data) => {
            return this.previewFileUrl(data.download_url);
          }
        });
      } else {
        return this.download();
      }
    },
    reupload: function() {
      this.currentAttachment._error_message = '';
      return this.currentAttachment.upload({
        error: function(error, xhr) {
          return this.currentAttachment._error_message = error.message;
        }
      });
    },
    clickAttachment: function(index) {
      if (index === this.currentIndex) {
        return;
      }
      return this.currentIndex = index;
    },
    previewPrev: function() {
      if (!this.hasPrevious) {
        return;
      }
      return this.preview(-1);
    },
    previewNext: function() {
      if (!this.hasNext) {
        return;
      }
      return this.preview(1);
    },
    updateCurrentIndex: function(index) {
      return this.currentIndex = index;
    },
    updateAttachments: function(attachments) {
      return this.attachments = attachments;
    },
    preview: function(delta) {
      this.currentIndex += delta;
      if (this.currentIndex > this.listViewLastIndex || this.currentIndex < this.listViewFirstIndex) {
        return this._calculateDeltaXAccordingIndex(Boolean(delta < 0));
      }
    },
    listForward: function() {
      if (!this.listHasPrevious) {
        return;
      }
      return this.changeDeltaX(this.perDeltaX * this.perDeltaCount);
    },
    listBackward: function() {
      if (!this.listHasNext) {
        return;
      }
      return this.changeDeltaX(-this.perDeltaX * this.perDeltaCount);
    },
    changeDeltaX: function(deltaX) {
      return this.deltaX += deltaX;
    },
    rotate: function() {
      var _rotate;
      if (!this.canPreview(this.currentAttachment)) {
        return;
      }
      if (_rotate = this.currentAttachment._rotate) {
        _rotate += 90;
        return this.currentAttachment._rotate = _rotate === 360 ? 0 : _rotate;
      } else {
        return Vue.set(this.currentAttachment, '_rotate', 90);
      }
    },
    scale: function(type) {
      var ratio;
      if (!this.canPreview(this.currentAttachment)) {
        return;
      }
      ratio = type === 'zoomIn' ? 0.1 : -0.1;
      return this.currentAttachment._scale = Math.max(this.currentAttachment._scale + ratio, 0.1);
    },
    initImageScale: function(event, attachemnt) {
      var content_height, content_width, img_height, img_width, preview_content, scale;
      preview_content = this.$refs.previewContent;
      content_width = preview_content.clientWidth;
      content_height = preview_content.clientHeight;
      img_width = event.target.width;
      img_height = event.target.height;
      scale = 1;
      if (img_width > img_height) {
        while (img_width > content_width) {
          scale = Math.max(scale - 0.1, 0.1);
          img_width *= scale;
        }
      } else {
        while (img_height > content_height) {
          scale = Math.max(scale - 0.1, 0.1);
          img_height *= scale;
        }
      }
      return Vue.set(attachemnt, '_scale', scale);
    },
    // focus后能使用左右方向键控制附件prev和next
    _focusLayer: function() {
      return this.$el.focus();
    },
    _isCurrentAttachment: function(attachment) {
      return attachment.id === this.currentAttachment.id;
    },
    _croppedAttachmentUrl: function(attachment) {
      return `/attachments/${attachment.id}/download_url?variant=logo`;
    },
    _adjustDeltaX: function() {
      if (this.deltaX > 0) {
        this.deltaX = 0;
      }
      if (Math.abs(this.deltaX) > this.thumbnailsListWidth - this.thumbnailsListMaxWidth) {
        return this.deltaX = -(this.thumbnailsListWidth - this.thumbnailsListMaxWidth);
      }
    },
    _calculateDeltaXAccordingIndex: function(toFirst = false) {
      var view_counts;
      // active显示在正数第二个
      if (toFirst) {
        return this.deltaX = -this.perDeltaX * (this.currentIndex - 1);
      } else {
        // 最多显示个数
        // active显示在倒数第二个
        view_counts = this.thumbnailsListMaxWidth / this.perDeltaX;
        return this.deltaX = this.currentIndex + 1 < view_counts ? 0 : -this.perDeltaX * (this.currentIndex + 2 - view_counts);
      }
    },
    __enableBackdrop: function() {
      return this.backdropID = Skylark.Helpers.App.capturedBackdrop((event) => {
        if (event.target.closest('.attachment-layer-footer') || event.target.closest('.attachment-preview')) {
          return {
            force_clean: false
          };
        } else {
          return this.close();
        }
      }, void 0);
    }
  }
});
